export default __webpack_public_path__ + "static/header-kontatk-min-dd1c3422a366b7725a7d7a248f9a32a5.jpg";